import src from "IMAGE";
export default { src, width: 468, height: 123, blurWidth: 0, blurHeight: 0};
